
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/ocean-technology/products/oceanographic-data-management-and-mapping-software",
      function () {
        return require("private-next-pages/industries/ocean-technology/products/oceanographic-data-management-and-mapping-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/ocean-technology/products/oceanographic-data-management-and-mapping-software"])
      });
    }
  